import Layout from '@/components/layout/Layout';
import { FC } from 'react';
import BookCardItem from '@/components/ui/book-card-item/BookCardItem';
import Pagination from '@/components/ui/pagination/Pagination';
import PageHeading from '@/components/ui/page-heading/PageHeading';
import Breadcrumbs from '@/components/ui/breadcrumbs/Breadcrumbs';
import { BOOKS_FOR_PAGE } from '@/helpers/variables';
import { getAuthorFullName } from '@/helpers/helpers';
import SectionTitleMenu from '@/components/ui/section-title-menu/SectionTitleMenu';
import { IReaderDetail } from '@/interfaces/readerDetail.interface';
import { useGetUrlPath } from '@/hooks/useGetUrlPath';

interface IReaderDetailProps {
  reader: IReaderDetail;
}

const ReaderDetail: FC<IReaderDetailProps> = ({ reader }) => {
  const pagesCount = Math.ceil(reader.person_books_count / BOOKS_FOR_PAGE);

  const readerFullName = getAuthorFullName(reader.first_name, reader.middle_name, reader.last_name);

  const SEO_TITLE = `${readerFullName} скачать бесплатно все книги чтеца в txt, pdf, DjVu, rtf или читать онлайн`;
  const SEO_DESCRIPTION = `${readerFullName} скачать бесплатно все книги чтеца в txt, pdf, DjVu, rtf или читать онлайн в электронной библиотеке КучаКниг.`;
  const SEO_CANONICAL = `/reader/${reader.alias}/`;

  return (
    <Layout title={SEO_TITLE} description={SEO_DESCRIPTION} canonicalHref={SEO_CANONICAL} pageHref={useGetUrlPath()}>
      <Breadcrumbs pageName={`${readerFullName}`} />

      <SectionTitleMenu>
        <PageHeading title={`Книги чтеца: ${readerFullName}`} extraClassName="pageHeading_plain" />
      </SectionTitleMenu>

      <div data-cards="list" className="cardsWrapper">
        {reader.books.length > 0 ? (
          reader.books.map((book) => (
            <BookCardItem
              key={book.id}
              book={book}
              authorAlias={book.author_alias}
              createdAt={book.created_at}
              alias={book.alias}
              author={{ first_name: book.author_first_name, middle_name: book.author_middle_name, last_name: book.author_last_name }}
              rating={book.rating}
            />
          ))
        ) : (
          <div>Книги не найдены</div>
        )}
      </div>

      <Pagination pagesCount={pagesCount ?? 0} postName={`reader/${reader.alias}/page=`} />
      {/* <Breadcrumbs pageName={`${readerFullName}`} /> */}
    </Layout>
  );
};

export default ReaderDetail;
